var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('nice-tabs',[_c('tab-device',{attrs:{"data-ni_tab_name":"Device"}}),_c('tab-map',{attrs:{"data-ni_tab_name":"Map"}}),_c('tab-table',{attrs:{"data-ni_tab_name":"Table"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }